var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.667 2.5a4.167 4.167 0 1 0 0 8.333 4.167 4.167 0 0 0 0-8.333M1.5 6.667a5.167 5.167 0 1 1 9.157 3.282l3.697 3.697a.5.5 0 0 1-.708.708L9.95 10.657a5.167 5.167 0 0 1-8.45-3.99",
    clipRule: "evenodd"
  })));
};
export { SvgSearch as ReactComponent };
export default __webpack_public_path__ + "c970e24ecd53ab367b2c64145ac60fbf.svg";